import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import '../Reports.scss';

export class PastDuePreRequisiteTaskFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            locationKeys: '',
            communityIds: '',
        }

        this.state = {
            emptyForm: initialFormSelections,
            locationKeys: initialFormSelections.locationKeys,
            communityIds: initialFormSelections.communityIds,
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = {...this.state};

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                locationKeys: appState.locationKeys ? appState.locationKeys : newState.locationKeys,
                communityIds: appState.communityIds ? appState.communityIds : newState.communityIds            
            }
        }

        // Possibly override app state values with default values or URL params
        let locationKeys = this.getDefaultLocationKeys(newState.locationKeys);

        newState = {
            ...newState,
            locationKeys: locationKeys
        }

        this.setState({
            ...this.state,
            ...newState
        });

    }

    getDefaultLocationKeys = (savedLocationKeys) => {
        /**
         * Location(s) can come from three places:
         *  1. The URL params
         *  2. Already selected Location Keys saved in app state
         *  3. The current user's default location
         *
         * When this report is called from the Task List page of the site, there is an attempt
         * to pass along any location(s) the user has already selected on that page, to auto-populate
         * the location field here.  We try to grab those values first.
         *
         * If the URL params location(s) aren't set, then we fallback to the selected location keys,
         * and if none have been selected, then we try to pull the default location from the current
         * user's default location.
         */

        
        if (Object.keys(this.props.urlParams).length > 0) {
            const urlLocationKeys = this.props.urlParams.locationKeys;
            if (urlLocationKeys && urlLocationKeys.length > 0) {
                return urlLocationKeys.join(',');
            }
            
            return '';
        }

        if (savedLocationKeys) {
            return savedLocationKeys;
        }
        
        const defaultLocationKey = this.props.filters.defaultLocationKey;

        if (defaultLocationKey && defaultLocationKey.trim().length > 0) {
            return defaultLocationKey;
        }

        return '';
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };

        form.locationKeys = (reportRequest.locationKeys) ? reportRequest.locationKeys.join(',') : form.locationKeys;
        form.communityIds = (reportRequest.communityIds) ? reportRequest.communityIds.join(',') : form.communityIds;

        this.setState({
            ...this.state,
            ...form
        });
    }

    mapToApiRequest = () => {
        const request = {
            reportId: this.props.report.id,
            locationKeys: this.state.locationKeys.split(','),
            communityIds: this.state.communityIds.split(',')
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onFieldChange = (name, value) => {
        this.setState({ ...this.state, [name]: value });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    render() {
        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="locationKeys"
                            label="Locations" idField="id" valueField="name"
                            options={this.props.filters.locations || []}
                            selectedValues={this.state.locationKeys.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            errorMessage="Location is required"
                            isMulti={true} />            
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="communityIds"
                            label="Communities" idField="id" valueField="name"
                            options={this.props.filters.communities || []}
                            selectedValues={this.state.communityIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            errorMessage="Community is required"
                            isMulti={true} />            
                    </div>
                </div>            
            </form>
        );
    }
}

PastDuePreRequisiteTaskFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    savedFilterValues: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
};

export default PastDuePreRequisiteTaskFilters;
